import { render, staticRenderFns } from "./dataTable.vue?vue&type=template&id=db93f5fe"
import script from "./dataTable.vue?vue&type=script&lang=js"
export * from "./dataTable.vue?vue&type=script&lang=js"
import style0 from "./dataTable.vue?vue&type=style&index=0&id=db93f5fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports